import { Pipe, PipeTransform } from '@angular/core';
import { canPaymentBeCancelled } from '../helpers/can-payment-be-cancelled';
import { Payment } from '../models/Payment';
import { Practice } from '../models/Practice';

@Pipe({name: 'canPaymentBeCancelled'})
export class CanPaymentBeCancelledPipe implements PipeTransform {
  transform(payment: Payment, practice: Practice): boolean {
    return canPaymentBeCancelled(payment,practice);
  }
}
